import { register } from "@builder.io/sdk-vue";
import { contentComponents } from "./builder/content";
import { formComponents } from "./builder/forms";
import { previewComponents } from "./builder/preview";
import { commerceComponents } from "./builder/commerce";

const componentOrder = [
    "Highlight",
    "Multistep Indicator",
    "Bubble Headline",
    "Form Tabs",
    "DT Button",
    "DT Input",
    "DT Date Input",
    "DT Select",
    "DT Color Radio",
    "Auto Profile AI",
    "Auto Profile AI 2",
    "Message Box",
    "DT Milestones",
    "Book Preview",
    "Merch Preview",
    "Change Request",
    "Expected Delivery",
    "Up Selling",
    "Selectable Upsells",
    "Payment Methods",
    "DT Email Submit",
    "DT Carousel",
];

const componentsByName = new Map([
    ...contentComponents,
    ...formComponents,
    ...previewComponents,
    ...commerceComponents,
].map((definition) => [definition.name, definition]));

export const registeredComponents = componentOrder.map((name) => componentsByName.get(name));

if (registeredComponents.some((definition) => !definition)) {
    throw new Error("Builder component registry is incomplete.");
}

register("insertMenu", {
    name: "DreamyTales Components",
    items: componentOrder.map((name) => ({ name })),
});
